import Breadcrumb from 'react-bootstrap/Breadcrumb';

import './breadcrub.css'
interface BreadcrumbProps {
    route: string;
    pageTitle: string;
}


function BreadcrumbExample({ route, pageTitle }: BreadcrumbProps) {
  return (
    <Breadcrumb className='custom-breadcrumb'>
      <Breadcrumb.Item href="/case-studies" className='' >Case Studies</Breadcrumb.Item>
      <Breadcrumb.Item href={route}>
        {pageTitle}
      </Breadcrumb.Item>

    </Breadcrumb>
  );
}

export default BreadcrumbExample;